module.exports = __webpack_public_path__ + "img/student.d5b59c0d.webp";